import {useSelector} from 'react-redux';
import {RootState} from '../../store/rootReducer';
import {useGetOrganizationEntitlementsQuery} from '../../store/endpoints/OrganizationsEndpoints';

/**
 * Whether this org gets AI-generated bundle suggestions in the bundle search table.
 *
 * Gated purely on the organization's aiBundleSuggestionsEnabled entitlement - the generate button and
 * suggestion panel already live behind the page's existing bundle permissions, so there is no separate
 * CASL check here. The client check is cosmetic, as always: a disabled server 503s these endpoints, so
 * the query is skipped rather than polled when this is false.
 */
export const useBundleSuggestionsAvailable = (): boolean => {
    const selectedOrganization = useSelector((state: RootState) => state.settings.selectedOrganization);
    const entitlements = useGetOrganizationEntitlementsQuery(selectedOrganization ?? '', {
        skip: !selectedOrganization || selectedOrganization === '',
    });

    return entitlements.data?.aiBundleSuggestionsEnabled === true;
};

export default useBundleSuggestionsAvailable;
